<template>
  <div class="general-wrapper">
    <Header class="marketplace-header">
      <template #title>
        <span class="v1-grey-2-color">
          {{ $t('navbar.marketplace') }}
        </span>
      </template>
      <template #actions>
        <div class="iqos-tooltip-helper-box mr-8">
          <BaseButton
            variant="secondary"
            color="v1-grey-2"
            @click="show_app_qrcode = !show_app_qrcode"
            size="md"
          >
            {{ $t("marketplace.download_btn") }}
          </BaseButton>

          <IQOSTooltip
            class="v1-grey-10-color"
            :title="'Marketplace QR'"
            qrLink="https://app.qrwaiter.com.ua/download"
            @close="show_app_qrcode = false"
            v-if="show_app_qrcode"
          >

          </IQOSTooltip>
        </div>

        <BaseButton
          variant="secondary"
          color="v1-grey-2"
          size="md"
          @click="openOrdersHistory"
          v-if="onComission && cafe.marketplace_agreed"
        >
          {{ $t("tables.orders_history") }}
        </BaseButton>
      </template>
    </Header>

    <div class="welcome-page" v-if="!cafe.marketplace_joined">
      <div class="info-section">
        <img src="/icons/qr-delivery.svg" alt="" />
        <h4 class="qrw-heading-xl bold">
         {{ $t('marketplace.land_title') }}
        </h4>
        <BaseButton
          @click="changeJoined(true)"
          variant="primary"
          color="red-3"
          size="lg"
          class="request-btn"
          >
          {{ $t('marketplace.land_connect') }}
          </BaseButton
        >
        <!-- <div class="numbers-block bold">
            <small class="qrw-label-sm">228 <br>
            cafes</small>
            <small class="qrw-label-sm">228 <br>
            cities</small>
            <small class="qrw-label-sm">228 <br>
            active users</small>
          </div> -->
      </div>
      <div class="picture-section">
        <img src="../assets/marketplace.png" alt="" />
      </div>
    </div>

    <PageContainer v-else>
      <!-- <MarketplaceBalanceCard v-if="onComission" /> -->
          
      <MarketplacePolicy class="mt-24"/>

      <FlavorsEditor class="mt-24"/>

      <div class="iqos-grid mt-24">
        <div class="iqos-column">
          <!-- <MarketplaceIQOS class="iqos-empty right-space" /> -->
          
        </div>
        <div class="iqos-column">
          <!-- <MarketplaceApp /> -->
          
        </div>
      </div>

      <!-- <TransactionsHistory class="iqos-empty" /> -->
    </PageContainer>
  </div>
</template>

<script>
import MarketplaceBalanceCard from "@/components/marketplace/MarketplaceBalanceCard.vue";
import TransactionsHistory from "@/components/billing/TransactionsHistory.vue";
import MarketplaceIQOS from "@/components/marketplace/MarketplaceIQOS.vue";
import BillingReminderPanel from "@/components/billing/BillingReminderPanel.vue";
import FlavorsEditor from "@/components/general/FlavorsEditor.vue";
import MarketplaceApp from "@/components/marketplace/MarketplaceApp.vue";

import MarketplacePolicy from "@/components/marketplace/MarketplacePolicy.vue";

import RemoteScroller from "@/components/RemoteScroller.vue";

import DashboardButton from "@/components/DashboardButton.vue";

import MarketplaceAPI from '@/api/marketplace'

export default {
  data() {
    return {
      show_app_qrcode: false
    };
  },
  methods: {
    openOrdersHistory() {
      this.$router.push("/table/marketplace");
    },
    changeAgreed(v) {
      this.$store.commit("setMarketplaceAgreed", !this.agreed);

      this.$store.dispatch("saveCafe");
    },
    changeJoined(v) {
      this.$store.commit("patchCafeGeneralData", {
        marketplace_joined: v
      });

      this.$store.dispatch("saveCafe");

      if (v) {
        MarketplaceAPI.connect(this.cafe._id);
      }
    }
  },
  computed: {
    onComission() {
      return this.$store.state.cafe.uses_comission;
    },
    cafe() {
      return this.$store.state.cafe;
    },
    agreed() {
      return this.$store.state.cafe.marketplace_agreed;
    },
    joined() {
      return this.$store.state.cafe.marketplace_joined;
    },
  },
  components: {
    MarketplaceBalanceCard,
    TransactionsHistory,
    MarketplaceIQOS,
    BillingReminderPanel,
    RemoteScroller,
    FlavorsEditor,
    DashboardButton,
    MarketplacePolicy,
    MarketplaceApp,
  },
};
</script>

<style scoped>
.w-65 {
  width: 65vh;
}
.h-100 {
  height: 100vh;
}
.h-82 {
  height: 82vh;
}

.marketplace-header {
  background: var(--red-3-color) !important;
  color: var(--white-color) !important;
}

.welcome-page {
  display: flex;
  justify-content: space-around;
  width: fit-content;
  padding: 0 120px;
  overflow: hidden;
}

.picture-section,
.info-section {
  width: 50%;
}

.info-section {
  align-self: center;
}

.info-section h4 {
  padding-top: 24px;
}

.picture-section img {
  width: 100%;
  height: auto;
}

.request-btn {
  margin-top: 56px;
}

.numbers-block {
  display: flex;
  padding-top: 56px;
}

.numbers-block small {
  text-align: center;
  color: var(--v1-grey-6-color);
  border-right: 1px solid var(--v1-grey-6-color);
  padding: 0 16px;
}

.numbers-block small:first-child {
  padding-left: 0;
}

.numbers-block small:last-child {
  border-right: 0;
}
</style>
